import { Link, useLocation } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'

/**
 * Catch-all 404 page. Replaces the previous `<Navigate to="/" />` so a typo'd
 * URL doesn't silently drop the user on the marketing page (which then
 * re-redirects authenticated users to /dashboard, producing two history
 * entries that collapse to one).
 */
const NotFoundPage = () => {
  const location = useLocation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const home = isAuthenticated ? '/dashboard' : '/'
  const homeLabel = isAuthenticated ? 'Back to dashboard' : 'Back to home'

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white p-6">
      <div className="text-center max-w-md">
        <div className="mx-auto w-16 h-16 rounded-full bg-white/10 border border-white/20 flex items-center justify-center mb-6">
          <Compass size={28} className="text-blue-100" />
        </div>
        <h1 className="serif-font text-3xl font-bold mb-3">Off the map</h1>
        <p className="text-blue-100/90 leading-relaxed mb-2">
          We couldn't find anything at <span className="font-mono text-amber-200">{location.pathname}</span>.
        </p>
        <p className="text-blue-100/70 text-sm mb-8">
          The link may be old, or the page may have moved.
        </p>
        <Link
          to={home}
          className="inline-block py-3 px-6 rounded-full bg-white text-blue-900 font-semibold hover:bg-blue-50 transition shadow-lg"
        >
          {homeLabel}
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
